export var TimePeriodGroupBy;
(function (TimePeriodGroupBy) {
    TimePeriodGroupBy["Days"] = "day";
    TimePeriodGroupBy["Hours"] = "hour";
    TimePeriodGroupBy["Minutes"] = "minute";
    TimePeriodGroupBy["Months"] = "month";
    TimePeriodGroupBy["Weeks"] = "week";
})(TimePeriodGroupBy || (TimePeriodGroupBy = {}));
export var ModelType;
(function (ModelType) {
    ModelType["Tag"] = "Tag";
    ModelType["Text"] = "Text";
    ModelType["Metric"] = "Metric";
})(ModelType || (ModelType = {}));
export var InteractionType;
(function (InteractionType) {
    InteractionType["Chat"] = "CHAT";
    InteractionType["Email"] = "EMAIL";
    InteractionType["Call"] = "CALL";
    InteractionType["Survey"] = "SURVEY";
    InteractionType["Messaging"] = "MESSAGING";
    InteractionType["SocialMedia"] = "SOCIAL_MEDIA";
})(InteractionType || (InteractionType = {}));
export var InteractionMetric;
(function (InteractionMetric) {
    InteractionMetric["AgentMessagesCount"] = "agentMessagesCount";
    InteractionMetric["AgentFirstResponseTime"] = "agentFirstResponseTime";
    InteractionMetric["AgentSatisfaction"] = "agentSatisfaction";
    InteractionMetric["AgentScore"] = "agentScore";
    InteractionMetric["AverageResponseTime"] = "meanResponseSeconds";
    InteractionMetric["BotMessagesCount"] = "botMessagesCount";
    InteractionMetric["CustomerMessagesCount"] = "customerMessagesCount";
    InteractionMetric["CustomerSatisfaction"] = "customerSatisfaction";
    InteractionMetric["ExperienceScore"] = "experienceScore";
    InteractionMetric["FirstResponseTime"] = "firstResponseTimeSeconds";
    InteractionMetric["HandlingTime"] = "handlingTimeSeconds";
    InteractionMetric["MessagesCount"] = "messagesCount";
    InteractionMetric["NetPromoterScore"] = "netPromoterScore";
    InteractionMetric["QueueTime"] = "queueTimeSeconds";
    InteractionMetric["QueryResolution"] = "isQueryResolved";
    InteractionMetric["ServiceLevelAgreement"] = "serviceLevelAgreementPercentage";
})(InteractionMetric || (InteractionMetric = {}));
export var MINIMUM_LABEL = "minimum";
export var MAXIMUM_LABEL = "maximum";
//# sourceMappingURL=common.js.map